import { commonDropdownFactory } from './chunk-KJW46MDQ.mjs';

// src/helpers/factories/menu/detailsFactories/itemsDetailsFactory.ts
var ITEM_SELL_BY_OPTIONS = [
  "unit" /* UNIT */,
  "weight" /* WEIGHT */,
  "volume" /* VOLUME */
];
var ITEM_WEIGHT_OPTIONS = [
  "kg" /* KG */,
  "g" /* G */,
  "lb" /* LB */,
  "oz" /* OZ */
];
var itemSellByDropdownFactory = (isMassUpdate) => commonDropdownFactory(
  ITEM_SELL_BY_OPTIONS,
  "menuScreen.itemDetails.dimensions.dimensionsSellBy.options",
  isMassUpdate
);
var itemWeightDropdownFactory = (isMassUpdate) => commonDropdownFactory(ITEM_WEIGHT_OPTIONS, "app.weightTypes", isMassUpdate);

export { ITEM_SELL_BY_OPTIONS, ITEM_WEIGHT_OPTIONS, itemSellByDropdownFactory, itemWeightDropdownFactory };
